module.exports = __webpack_public_path__ + "static/media/wallet-send-money.b65e49ba.png";